export const blockIconsCommunicationSpeakerNotesNew = (
	<span className='material-symbols-outlined'>speaker_notes</span>
);
